export default __webpack_public_path__ + "static/media/017-mosque.db8145eb.svg";